<script setup lang="ts">
patchChangelog()

// Das Benutzerobjekt wird nicht-blockierend geladen:
// authStore.fetchUser() (aufgerufen durch initializeAuth oder das Plugin) ist asynchron und aktualisiert den Store.
// Komponenten, die das Benutzerobjekt benötigen, können es reaktiv aus dem Store beziehen.
</script>

<template>
  <div>
    <NuxtRouteAnnouncer />
    <UApp>
      <AppCommandPalette />
      <NuxtLayout>
        <NuxtPage />
      </NuxtLayout>
    </UApp>
  </div>
</template>
